"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DialogLoadingOverlay = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useTranslations = require("../../hooks/useTranslations");
var _sharedStyles = require("./sharedStyles");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { ownerState: { isFullScreen } } = param;
    return {
        ..._sharedStyles.sharedLoadingStyles,
        ...isFullScreen && {
            left: 0,
            position: 'fixed',
            top: 0,
            width: '100%'
        }
    };
});
const DialogLoadingOverlay = exports.DialogLoadingOverlay = /*#__PURE__*/ (0, _react.memo)((param)=>{
    let { id, isFullScreen = false } = param;
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _useTranslations.useTranslations)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        ownerState: {
            isFullScreen
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.CircularProgress, {
            color: "primary",
            "aria-label": formatMessage('loading'),
            ...getTestIdProps(id)
        })
    });
});
